module.exports = __webpack_public_path__ + "static/media/ic-season-spring.d31994f4.svg";